import { defineComponent as _defineComponent } from 'vue'
import {computed, reactive, toRefs} from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticOrderSummariesTable',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    // Row-shaped figures of all items, calculated by the server
    total: {
      type: Object,
      default: () => ({})
    },
    // Row-shaped figures of all items in the comparison month, usually the same month one year earlier
    comparisonTotal: {
      type: Object,
      default: () => ({})
    },
    overview: {
      type: Boolean,
      default: true
    }
  },
  emits: ["itemClicked"],
  setup(__props, { emit }) {

const props = __props

  

  const initialState = {
    footerClassObject: {
      "pa-2": true
    },
    headerClassObject: {
      "pa-2": true,
      cell: true,
      "no-padding": true
    },
    itemsPerPage: 10,
    paddingValue: "pa-2"
  };

  const state = reactive({...initialState});

  const {footerClassObject, headerClassObject, itemsPerPage} = toRefs(state);

  

  function itemClicked(entry: any) {
    emit("itemClicked", entry);
  }

  const headers = computed(() => {
    const headers = new Array<any>();
    headers.push({
      text: "Name",
      align: "left",
      value: "order.name",
      class: state.paddingValue
    });

    if (!props.overview) {
      headers.push({
        text: "Stadt",
        align: "left",
        value: "order.city",
        class: state.paddingValue
      });
    }

    headers.push({
                   text: "Stunden",
                   align: "right",
                   value: "minutes",
                   class: state.paddingValue
                 },
                 {
                   text: "Kosten",
                   align: "right",
                   value: "costs",
                   class: state.paddingValue
                 },
                 {
                   text: "Kosten (inkl. LNK)",
                   align: "right",
                   value: "costsWithPayrollTaxes",
                   class: state.paddingValue
                 },
                 {
                   text: "Kosten (Fahrt)",
                   align: "right",
                   value: "costsTravel",
                   authorization: "costsTravel",
                   class: state.paddingValue
                 },
                 {
                   text: "Kosten (Mitfahrer)",
                   align: "right",
                   value: "costsPassenger",
                   authorization: "costsTravel",
                   class: state.paddingValue
                 },
                 {
                   text: "Zuschüsse",
                   align: "right",
                   value: "perDiem",
                   class: state.paddingValue
                 },
                 {
                   text: "Einnahmen",
                   align: "right",
                   value: "earnings",
                   authorization: "Accounting_Overview_ViewWageAndCosts",
                   class: state.paddingValue
                 },
                 {
                   text: "Ausgaben",
                   align: "right",
                   value: "expenses",
                   authorization: "Accounting_Overview_ViewWageAndCosts",
                   class: state.paddingValue
                 },
                 {
                   text: "Gewinn",
                   align: "right",
                   value: "profit",
                   authorization: "Accounting_Overview_ViewWageAndCosts",
                   class: state.paddingValue
                 },
                 {
                   text: "Stundenlohn (avg)",
                   align: "right",
                   value: "averageWage",
                   authorization: "Accounting_Overview_ViewWageAndCosts",
                   class: state.paddingValue
                 },
                 {
                   text: "Produktivität",
                   align: "right",
                   value: "productivity",
                   authorization: "Accounting_Overview_ViewWageAndCosts",
                   class: state.paddingValue
                 },
                 {
                   text: "",
                   align: "right",
                   value: "id",
                   sortable: false,
                   class: state.paddingValue
                 });

    return headers;
  });


return { __sfc: true,props, initialState, state, footerClassObject, headerClassObject, itemsPerPage, emit, itemClicked, headers }
}

})